/**
 * Platform Detection Utilities
 * 
 * Functions to detect browser, OS, and device characteristics.
 * Used for platform-specific audio handling and UI adjustments.
 */

/**
 * Detect if the user is on Android Chrome (not Edge or Firefox)
 * 
 * This is important for audio handling because Android Chrome has specific
 * volume control quirks when getUserMedia() is active.
 */
export function isAndroidChrome(): boolean {
  const ua = navigator.userAgent;
  return /Android/i.test(ua) && /Chrome/i.test(ua) && !/Edg/i.test(ua) && !/Firefox/i.test(ua);
}

/**
 * Check if the device is mobile (Android or iOS)
 */
export function isMobile(): boolean {
  const ua = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

/**
 * Check if the device is iOS (iPhone, iPad, iPod)
 */
export function isIOS(): boolean {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua);
}
